export default {
    translations: {
      loginPage: {
        welcome: 'Bem-vindo',
        document: 'CPF',
        action: 'Avançar',
        invalidUser: 'Usuário em processo de cadastro ou não cadastrado'
      },
      errorPage: {
        backbutton: 'Voltar',
        header: 'Notamos que você já passou por uma consulta. Acesse o Smart Fit App para agendar uma nova consulta.',
        subtitle: 'A experiência do aplicativo é muito melhor. Através dele você consegue acessar seus treinos, agendar e remarcar novas consultas e recebe notificações para não perder nada.',
        download: 'Baixe agora mesmo!',
        action: 'Baixar o app'
      },
      schedulePage: {
        title: 'Agora escolha o melhor dia e horário para você realizar sua consulta',
        loading: 'Aguarde. Procurando datas disponíveis para agendamento....',
        unavailable: 'Parece que não há horários disponíveis para este dia',
        datePreposition: 'de',
        action: 'Avançar'
      },
      confirmationPage: {
        title: 'Consulta agendada com sucesso!',
        datePreposition: 'às',
        coach: 'Coach',
        reschedule: 'Remarcar',
        important: 'Importante!',
        downloadInfo: 'Baixe o nosso aplicativo. É através dele que você receberá seus treinos para realizar onde quiser!',
        downloadAction: 'baixar o smart fit app',
        callInfo: 'A vídeo chamada será realizada pelo Whatsapp. O seu Coach entrará em contato com você 10 minutos antes do seu atendimento.',
        confirmationInfo: 'Se não puder comparecer, cancele seu agendamento',
        confirmationInfoBold: 'com pelo menos 12 horas de antecedência',
        confirmationInfoTwo: 'Se você cancelar com menos tempo, só poderá fazer um novo agendamento uma semana depois.',
        action: 'Ir para o site smart fit',
        modal: {
          title: 'utilize nosso app',
          subtitle: 'Por lá você consegue cancelar e remarcar seus agendamentos facilmente e recebe notificações para não perder nenhuma consulta.',
          subtitleBold: 'Baixe agora mesmo!',
          subtitleAppBold: 'Baixe agora mesmo e acesse com seu CPF cadastrado no Smart Fit Coach.',
          appAction: 'baixar o smart fit'
        }
      },
      utils: {
        monthsAbbr: {
          january: 'jan',
          february: 'feb',
          march: 'mar',
          april: 'abr',
          may: 'mai',
          june: 'jun',
          july: 'jul',
          august: 'aug',
          september: 'set',
          october: 'out',
          november: 'nov',
          december: 'dec'
        },
        weekDaysAbbr: {
          sunday: 'dom',
          monday: 'seg',
          tuesday: 'ter',
          wednesday: 'qua',
          thursday: 'qui',
          friday: 'sex',
          saturday: 'sab',
        },
        languages: {
          pt_BR: 'Português - Brasil',
          es_CL: 'Espanhol - Chile',
          es_CO: 'Espanhol - Colômbia',
          es_MX: 'Espanhol - México',
          es_PE: 'Espanhol - Peru',
          es_PA: 'Español - Panamá',
          es_CR: 'Español - Costa Rica',
        }
      },
    }
  }
